import Axios from '../../axiosConfig';
import { BACKEND_URL } from '../../config';
import { configure, runInAction, makeAutoObservable } from 'mobx';
import { DocumentTypeDto } from '../../types/document';
import { LocalizedName } from '../../types/localization';
import { ChapterTemplateDto } from '../../types/chapterTemplate';

configure({ enforceActions: 'observed' });

export default class ChapterTemplateModule {
    private docTypes: DocumentTypeDto[] = [];
    private chapTemplates: ChapterTemplateDto[] = [];
    private availableTipTypes: LocalizedName[] = [];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public async fetchAllChapterTemplates(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + 'chapterTemplate/listAllChapterTemplates',
            withCredentials: true,
        });
        if (response.status === 200) runInAction(() => (this.chapTemplates = response.data));
    }

    public async fetchAvailableDocTypes(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + 'chapterTemplate/getAvailableDocTypesAndDescriptions',
            withCredentials: true,
        });
        if (response.status === 200) runInAction(() => (this.docTypes = response.data));
    }

    public async fetchAvailableTipTypes(): Promise<void> {
        const response = await Axios({
            method: 'GET',
            url: BACKEND_URL + 'template/getAvailableTipTypesAndDescriptions',
        });
        if (response.status === 200) runInAction(() => (this.availableTipTypes = response.data));
    }

    public async saveChapterTemplate(template: ChapterTemplateDto): Promise<void> {
        const response = await Axios({
            method: 'POST',
            url: BACKEND_URL + 'chapterTemplate/createChapterTemplate',
            data: template,
            withCredentials: true,
        });

        const newTemplate = response.data as ChapterTemplateDto;
        runInAction(() => {
            this.chapTemplates.push(newTemplate);
        });
    }

    public async updateChapterTemplate(template: ChapterTemplateDto): Promise<void> {
        const response = await Axios({
            method: 'PUT',
            url: BACKEND_URL + `chapterTemplate/updateChapterTemplate/${template.id}`,
            data: template,
            withCredentials: true,
        });

        const updatedTemplate: ChapterTemplateDto = response.data;
        runInAction(() => {
            const index = this.chapTemplates.findIndex((template) => template.id === updatedTemplate.id);
            this.chapTemplates[index] = updatedTemplate;
            this.chapTemplates = this.chapTemplates.map((template) => {
                if (template.title?.id === updatedTemplate.title?.id) {
                    template.title = updatedTemplate.title;
                    return template;
                }
                return template;
            });
        });
    }

    public async deleteChapterTemplate(id: number): Promise<void> {
        await Axios({
            method: 'DELETE',
            url: BACKEND_URL + `chapterTemplate/removeChapterTemplate/${id}`,
            withCredentials: true,
        });

        runInAction(() => {
            this.chapTemplates = this.chapTemplates.filter((template) => template.id !== id);
        });
    }

    public get documentTypes(): DocumentTypeDto[] {
        return this.docTypes;
    }

    public get tipTypes(): LocalizedName[] {
        return this.availableTipTypes;
    }

    public get chapterTemplates(): ChapterTemplateDto[] {
        return this.chapTemplates
            .slice()
            .sort((a, b) =>
                a.type.code > b.type.code
                    ? 1
                    : a.type.code < b.type.code
                    ? -1
                    : 0 || a.orderNumber > b.orderNumber
                    ? 1
                    : -1,
            );
    }
}
